// extracted by mini-css-extract-plugin
export default {"root":"ftY7g","items":"_3DSZr","item":"_3ISzd","is-selected":"_32NWv","isSelected":"_32NWv","user":"_2Clk4"};